import { ClientAdvanceSettlementSourceType } from "../features/ClientAdvanceSettlements/constants/client-advance-settlement.constants";
import { EmployeeAdvanceSettlementSourceType } from "../features/EmployeeAdvanceSettlements/constants/employee-advance-settlement.constants";
import { ClientAdvanceSourceType } from "../features/ClientAdvances/constants/client-advance.constants";
import { InvoiceSourceType } from "../features/Invoices/constants/invoice.constants";
import { PaymentSourceType } from "../features/Payments/constants/payment.constants";
import { QuotationSourceType } from "../features/Quotations/constants/quotation.constants";
import { WorkAssignmentSourceType } from "../features/WorkAssignments/constants/work-assignment.constants";
import { WorkOrderSourceType } from "../features/WorkOrders/constants/work-order.constants";

export type AnySourceType =
  | WorkOrderSourceType
  | QuotationSourceType
  | ClientAdvanceSourceType
  | PaymentSourceType
  | ClientAdvanceSettlementSourceType
  | EmployeeAdvanceSettlementSourceType
  | InvoiceSourceType
  | WorkAssignmentSourceType;

/** Paths by source-type string. Shared enum values (e.g. `AMC`) map once. */
export const SOURCE_TYPE_URL_MAP: Record<AnySourceType, string> = {
  [WorkOrderSourceType.QUOTATION]: "/quotations",
  /** `AMC` is shared by {@link WorkOrderSourceType.AMC}, {@link QuotationSourceType.AMC}, and {@link ClientAdvanceSourceType.AMC}. */
  [QuotationSourceType.AMC]: "/amc-management",
  [QuotationSourceType.ENQUIRY]: "/enquiry-management/enquiries",
  /** Shared by {@link WorkOrderSourceType.AMC_VISIT} and {@link InvoiceSourceType.AMC_VISIT} (`AMC_VISIT`). */
  [InvoiceSourceType.AMC_VISIT]: "/amc-management/visit-logs",
  /** Shared by {@link InvoiceSourceType.WORK_ORDER} and {@link ClientAdvanceSourceType.WORK_ORDER}. */
  [InvoiceSourceType.WORK_ORDER]: "/work-orders",
  [PaymentSourceType.CLIENT_ADVANCE]: "/finance/client-advances",
  [PaymentSourceType.CLIENT_ADVANCE_REFUND]: "/finance/client-advances",
  [PaymentSourceType.EMPLOYEE_ADVANCE]: "/finance/employee-advances",
  [PaymentSourceType.EMPLOYEE_ADVANCE_REFUND]: "/finance/employee-advances",
  [PaymentSourceType.INVOICE]: "/finance/invoices",
  [PaymentSourceType.PAYROLL_ITEM]: "/finance/payroll",
  [PaymentSourceType.OTHER]: "/finance/payments",
  [ClientAdvanceSettlementSourceType.MANUAL]: "/finance/client-advance-settlements",
  [EmployeeAdvanceSettlementSourceType.PAYROLL]: "/finance/payroll",
  /** Shared by {@link InvoiceSourceType.PETTY_WORK} and {@link ClientAdvanceSourceType.PETTY_WORK}. */
  [InvoiceSourceType.PETTY_WORK]: "/petty-works",
  [WorkAssignmentSourceType.SITE_VISIT]: "/enquiry-management/site-visits",
};
